<template>
    <b-card
        :class="['list-container']"
        bg-variant="white"
        no-body
    >
        <template #header>
            <div class="d-flex align-items-center justify-content-between" style="height: 36px">
                <div >
                    <h6 class="mb-0">평가 참여 정보</h6>
                </div>
            </div>
        </template>
        <b-table :items="selected_company.projects"
                 :fields="companyRequestColumn"
                 :empty-html="getEmptyTableHTML"
                 :sticky-header="true"
                 class="mb-0 sticky-header-sort-fix custom-table"
                 show-empty
        >

            <template #empty="">
                <div class="h6 gray-500 font-weight-normal text-center mb-0 py-3">
                    참여중인 프로젝트가 없습니다.
                </div>
            </template>
            <template #cell(status_code)="data">
                <b-badge :variant="getProgressColor(data.item)" class="mr-2">
                    {{ progressLabel(data.item) }}
                </b-badge>
            </template>

            <template #cell(member)="data">
                <!-- 조회 중에는 다른 행도 막아 늦게 온 응답이 다른 프로젝트 창을 덮지 않게 한다 -->
                <b-button size="sm" variant="dark-border"
                          :disabled="loadingRequestId !== null"
                          @click="manageProjectMember(data.item)"
                >
                    <b-spinner v-if="loadingRequestId === data.item.request_id" small/>
                    <fa v-else icon="check"></fa>
                    참여자 보기
                </b-button>
            </template>

            <template #cell(status)="data">
                <b-button size="sm" variant="dark-border"
                          @click="enterProject('project', data.item, 'ProjectProgress')"
                >
                    <fa icon="check"></fa>
                    확인하기
                </b-button>
            </template>
        </b-table>


        <AssessmentMemberModal ref="assessment-member-modal"
                               :selected_company="selected_company"
                               :read-only="readOnly"
                               @closed="onMemberModalClosed"
        />
    </b-card>
</template>


<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import assessmentCommonMixin from '@shared/mixin/assessment.common.mixin';
import { companyRequestColumn, PROGRESS_STATUS_LABELS } from '@shared/components/admin/pages/Management/Company/data';
import {getEmptyTableHTML} from '@shared/components/admin/pages/Management/common-data';
import AssessmentMemberModal from './AssessmentMemberModal.vue';

export default  {
    name: 'AdminCompanyAssessmentInfo',
    components: {
        fa: FontAwesomeIcon,
        AssessmentMemberModal
    },
    mixins: [
        assessmentCommonMixin  
    ],
    props: {
        selected_company: {
            type: Object,
            default: () => ({})
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
        // 기업 상세 라우트에서만 true — 열린 참여자 창을 ?members=<request_id> 로 남긴다 (목록 위 모달에서 쓰면 목록이 재조회됨)
        syncRoute: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {
            loadingRequestId: null,
        };
    },
    computed: {
        getEmptyTableHTML() {
            return getEmptyTableHTML('조회된 평가 정보가 없습니다.', '521px');
        },
        companyRequestColumn() {
            return companyRequestColumn.map(column => {
                column.label = this.$t(column.label);
                return column;
            });
        },
    },
    mounted() {
        // ?members= 로 들어오면 그 프로젝트의 참여자 창을 연다. 없는 신청 건이면 키를 지운다
        if (!this.syncRoute || this.$route.query.members == null) return;
        const project = (this.selected_company.projects || []).find(p => String(p.request_id) === String(this.$route.query.members));
        if (project) {
            this.manageProjectMember(project);
        } else {
            this.setMembersQuery(null);
        }
    },
    methods: {
        progressLabel(item) {
            const status = this.getProgressStatus(item);
            return PROGRESS_STATUS_LABELS[status] || status;
        },
        async manageProjectMember (project) {
            if (this.loadingRequestId !== null) return;
            this.loadingRequestId = project.request_id;
            try {
                const opened = await this.$refs['assessment-member-modal'].manageProjectMember(project);
                if (this.syncRoute) this.setMembersQuery(opened ? project.request_id : null);
            } finally {
                this.loadingRequestId = null;
            }
        },
        onMemberModalClosed() {
            if (this.syncRoute) this.setMembersQuery(null);
        },
        setMembersQuery(requestId) {
            const {members, ...rest} = this.$route.query;
            const next = requestId != null ? String(requestId) : undefined;
            if (members === next) return;
            this.$router.replace({query: next ? {...rest, members: next} : rest}).catch(() => {});
        },
        async enterProject(admin, project, mode) {
            this.$router.push({ name: mode, query: { client: project.client, pc: project.project_code, cmp: project.campaign_id, admin_mode: admin  } });
        },
    }
};
</script>
